'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresDeparture = function () {
    function WinresDeparture($scope, urlService, departureService, localizationService) {
        _classCallCheck(this, WinresDeparture);

        this.$scope = $scope;
        this.urlService = urlService;
        this.departureService = departureService;
        this.localizationService = localizationService;
    }

    _createClass(WinresDeparture, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Destination code for current page.
            this.winresReservationContext.$scope.destinationCode = this.destinationCode;

            // Needed to show tabs.
            // Storing this in $scope doesn't work since there can be
            // multiple <winres-reservation-context> elements that use
            // the same context but have different $scopes!
            this.winresReservationContext.$scope.isDeparture = 'true';
            this.winresReservationContext.context.isDefinitelyDeparture = true;

            // Flag current page as kohdesivu.
            this.winresReservationContext.urlService.isFixedKohdeSivu = true;

            // Re-init Google analytics watches with isFixedKohdeSivu.
            this.winresReservationContext.analyticsInitWatches();

            this.getNextReservablePeriod();

            this.$scope.$on('$locationChangeSuccess', function () {
                _this.getNextReservablePeriod();
            });
        }
    }, {
        key: 'getNextReservablePeriod',
        value: function getNextReservablePeriod() {
            var _this2 = this;

            var ctxdir = this.winresReservationContext;
            if (ctxdir && ctxdir.Params && ctxdir.Params.StartDate && ctxdir.Params.EndDate) {
                console.log('[winres-departure]', 'No need to find a departure since we already have one in the URL.');
                return;
            } else {
                console.log('[winres-departure]', 'Finding next departure. Destination:', this.destinationCode);
            }

            var searchCriteria = {
                'Language': this.localizationService.getLanguage(),
                'Offset': 0,
                'BeginDate': moment().format('YYYY-MM-DD'), // This day.
                'EndDate': null,
                'DestCodes': [this.destinationCode],
                'NumAdults': 2,
                'Limit': 1
            };

            this.winresReservationContext.context.mustWaitDeparture = true;

            this.departureService.searchDepartures(searchCriteria).then(function (result) {
                var departure = result.Results[0];

                if (departure != null) {
                    // Set next reservable begin and end date for current page.
                    _this2.winresReservationContext.$scope.startDate = departure.StartDate;
                    _this2.winresReservationContext.$scope.endDate = departure.EndDate;

                    // Num of people.
                    _this2.winresReservationContext.$scope.numAdults = 2;
                    _this2.winresReservationContext.$scope.numChildren = 0;
                    _this2.winresReservationContext.$scope.numInfants = 0;

                    // Update data for departure.
                    _this2.winresReservationContext.initUrlData();
                    _this2.winresReservationContext.initPassengerFieldsBase();
                    _this2.winresReservationContext.initPassengers();
                    _this2.winresReservationContext.loadDestination();

                    // Reset loading departure for full refresh.
                    _this2.winresReservationContext.loadingDeparture = {
                        "DestinationCode": null,
                        "StartDate": null,
                        "EndDate": null
                    };

                    // Load the actual departure.
                    _this2.winresReservationContext.loadDeparture();

                    _this2.winresReservationContext.context.mustWaitDeparture = false;
                }
            });
        }
    }]);

    return WinresDeparture;
}();

WinresDeparture.$inject = ['$scope', 'urlService', 'departureService', 'localizationService'];

_module3.default.component('winresDeparture', {
    // templateUrl: getTemplate,
    controller: WinresDeparture,
    bindings: {
        // Fixed destination code for current page.
        destinationCode: '@'
    },
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDeparture/winresDeparture.js
// module id = 298
// module chunks = 2